export const SessionTimeoutModalController = angular
    .module('app.components.sessionTimeoutModal.sessionTimeoutModalController', [
        'ngMaterial'
    ]).controller('SessionTimeoutModalController', (
        $scope,
        $mdDialog
    ) => {
        $scope.close = $mdDialog.hide;
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/sessionTimeoutModal/sessionTimeoutModal.controller.js